import Layout from './layout';
import { LayoutProps } from '../@types/schema';
import clsx from 'clsx';
import dynamic from 'next/dynamic';

const SeoFooter = dynamic(() => import('@nrdy-marketing-engine/footer/src/seo-footer'));

const SeoLayout = ({ theme, mainClassName, children, ...props }: LayoutProps) => {
  const mainClasses = clsx('flex-1', mainClassName);

  return (
    <Layout {...props} renderFooter={SeoFooter}>
      <main className={mainClasses}>{children}</main>
    </Layout>
  );
};

export default SeoLayout;
